// [CASH-MODE] Small helpers for UPI / Cash display.
import { PAYMENT_MODES } from '../constants/paymentModes';

/** 'UPI' | 'CASH' for a row (rows without the field are UPI). */
export const rowPaymentMode = (row) =>
  (row && String(row.paymentMode || '').toUpperCase() === PAYMENT_MODES.CASH ? PAYMENT_MODES.CASH : PAYMENT_MODES.UPI);

/** Human label: 'UPI' or 'Cash'. Use in tables, CSV and PDF exports. */
export const paymentModeLabel = (rowOrMode) => {
  const mode = typeof rowOrMode === 'string' ? rowOrMode.toUpperCase() : rowPaymentMode(rowOrMode);
  return mode === PAYMENT_MODES.CASH ? 'Cash' : 'UPI';
};

/** Value to send to the API: undefined for ALL so existing requests stay unchanged. */
export const paymentModeParam = (mode) =>
  (mode === PAYMENT_MODES.UPI || mode === PAYMENT_MODES.CASH ? mode : undefined);

/** Client-side filter for rows already loaded. */
export const filterRowsByMode = (rows, mode) =>
  (mode === PAYMENT_MODES.UPI || mode === PAYMENT_MODES.CASH
    ? (rows || []).filter((r) => rowPaymentMode(r) === mode)
    : rows || []);

/**
 * Client-side totals by mode (used when the API does not return totalsByMode).
 * @param rows array
 * @param getAmount (row) => number
 * @returns { UPI: { count, amount }, CASH: { count, amount } }
 */
export const totalsByModeFromRows = (rows, getAmount = (r) => r.amount) => {
  const totals = { UPI: { count: 0, amount: 0 }, CASH: { count: 0, amount: 0 } };
  (rows || []).forEach((r) => {
    const t = totals[rowPaymentMode(r)];
    t.count += 1;
    t.amount += Number(getAmount(r)) || 0;
  });
  return totals;
};
